import { useAuth } from "react-oidc-context";
import { Alert, BodyShort, Link } from "@digital-services-gard-as/anchor-react";
import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import ExternalLandingPage from "./_components/externalLandingPage";
import { attributesIsCIAFlags } from "@/auth/customAttributes";

import { LandingPage } from "./_components/landingPage";

export const Home = () => {
    const auth = useAuth();
    const { t } = useTranslation("claimsInvoicesOverview");

    if (auth.error) {
        throw new Error("An error occurred while trying to authenticate the user.");
    }

    if (!auth.isAuthenticated) {
        return <ExternalLandingPage />;
    }

    const customAttributes = auth.user?.profile.custom_attributes;

    if (
        !attributesIsCIAFlags(customAttributes) ||
        customAttributes.CIA_enabled_contact !== "true" ||
        customAttributes.CIA_enabled_company !== "true"
    ) {
        return (
            <Flex justifyContent="center" mt="4rem">
                <Alert id="missingAccessAlert" variant="warning">
                    <BodyShort>
                        {t("missingAccess")}{" "}
                        <Link href="mailto:claims.invoicing@gard.no">claims.invoicing@gard.no</Link>
                    </BodyShort>
                </Alert>
            </Flex>
        );
    }

    return <LandingPage />;
};
